export enum LanguageLabel {
  ENGLISH = 'English',
  GERMAN = 'Deutsch',
  CZECH = 'Česky',
  SLOVAK = 'Slovensky',
  POLISH = 'Polski',
  POLISH_BDO = 'Polski BDO',
}
